import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import {List} from "immutable";
import _ from "lodash";
import {isInt} from 'validator';

// Actions
import { createCustomer, cleanCustomers } from "../../../actions/customers";
import {getSeries, cleanSeries} from "../../../actions/series";

// Components
import { paymentTypes } from '../../../components/common/payment-types';
import Select from "../../../components/common/virtualized-select";
import SerieSelector from "../../../components/common/SerieSelector";

class NewCustomer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            customer_code: '',
            account_code: '',
            basic_info_name: '',
            basic_info_fiscal_id: '',
            basic_info_fiscal_name: '',
            basic_info_address: '',
            basic_info_postal_code: '',
            basic_info_city: '',
            basic_info_province: '',
            basic_info_country: '',
            basic_info_phone: '',
            basic_info_mobile_phone: '',
            basic_info_fax: '',
            basic_info_email: '',
            contact_person_name: '',
            contact_person_phone: '',
            contact_person_email: '',
            bank_info_name: '',
            bank_info_iban: '',
            bank_info_swift: '',
            payment_type: -1
        };
    }
    componentDidMount() {
        this.props.getSeries({ document_type: 'customer' });
    }
    componentDidUpdate(prevProps, prevState) {
        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue })
        }
    }
    componentWillUnmount() {
        this.props.cleanCustomers();
        this.props.cleanSeries();
    }

    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            customer_code: ''
        }, this.validateCustomer);
    };
    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateCustomer);
    };
    validateCustomer = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.customer_code !== '') &&
            this.state.account_code !== '' &&
            this.state.basic_info_name !== '' &&
            this.state.basic_info_fiscal_id !== '' &&
            this.state.basic_info_fiscal_name !== '' &&
            this.state.basic_info_address !== '' &&
            this.state.basic_info_postal_code !== '' &&
            this.state.basic_info_city !== '' &&
            this.state.basic_info_province !== '' &&
            this.state.contact_person_name !== '' &&
            this.state.bank_info_name !== '' &&
            this.state.payment_type !== -1
        ) {
            this.setState({
                canSubmit: true
            });
        } else {
            this.setState({
                canSubmit: false
            });
        }
    };
    handleCreateClick = () => {
        const {
            serieSelectedId,
            customer_code,
            account_code,
            basic_info_name,
            basic_info_fiscal_id,
            basic_info_fiscal_name,
            basic_info_address,
            basic_info_postal_code,
            basic_info_city,
            basic_info_province,
            basic_info_country,
            basic_info_phone,
            basic_info_mobile_phone,
            basic_info_fax,
            basic_info_email,
            contact_person_name,
            contact_person_phone,
            contact_person_email,
            bank_info_name,
            bank_info_iban,
            bank_info_swift,
            payment_type
        } = this.state;

        this.props.createCustomer({
            serieSelectedId,
            customer_code,
            account_code,
            basic_info: {
                name: basic_info_name,
                fiscal_id: basic_info_fiscal_id,
                fiscal_name: basic_info_fiscal_name,
                address: basic_info_address,
                postal_code: basic_info_postal_code,
                city: basic_info_city,
                province: basic_info_province,
                country: basic_info_country,
                phone: basic_info_phone,
                mobile_phone: basic_info_mobile_phone,
                fax: basic_info_fax,
                email: basic_info_email
            },
            contact_person: {
                name: contact_person_name,
                phone: contact_person_phone,
                email: contact_person_email
            },
            bank_info: {
                name: bank_info_name,
                iban: bank_info_iban,
                swift: bank_info_swift
            },
            payment_type
        });
        this.props.history.goBack();
    };

    render() {
        const {
            canSubmit,
            customer_code,
            account_code,
            basic_info_name,
            basic_info_fiscal_id,
            basic_info_fiscal_name,
            basic_info_address,
            basic_info_postal_code,
            basic_info_city,
            basic_info_province,
            basic_info_country,
            basic_info_phone,
            basic_info_mobile_phone,
            basic_info_fax,
            basic_info_email,
            contact_person_name,
            contact_person_phone,
            contact_person_email,
            bank_info_name,
            bank_info_iban,
            bank_info_swift,
            payment_type
        } = this.state;

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/clientes">Clientes</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Cliente</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.goBack() }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Código de Cliente *</label>
                                                        <div className="row">
                                                            <div className="col" style={{ paddingRight: 0 }} >
                                                                { this.state.serieSelectedId === 'manual'
                                                                    ? <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={customer_code}
                                                                        onChange={ (event) => {
                                                                            this.setState({
                                                                                customer_code: event.target.value
                                                                            }, this.validateCustomer);
                                                                        }}
                                                                    />
                                                                    : <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={ this.state.serieSelectedValue }
                                                                        disabled={true}
                                                                    />
                                                                }
                                                            </div>
                                                            <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                                { this.props.series.size > 0
                                                                    ? <SerieSelector
                                                                        series={this.props.series}
                                                                        serieSelectedId={this.state.serieSelectedId}
                                                                        onChangeSerieSelected={this.onChangeSerieSelected}
                                                                    />
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>NIF/CIF *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_fiscal_id}
                                                            onChange={ (event) => this.onChangeInput('basic_info_fiscal_id', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Cuenta Contable *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={account_code}
                                                            onChange={ (event) => {
                                                                const account_code = event.target.value;
                                                                if (isInt(account_code) || account_code === '') {
                                                                    this.onChangeInput('account_code', account_code);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label>Nombre comercial *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_name}
                                                            onChange={ (event) => this.onChangeInput('basic_info_name', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label>Nombre fiscal *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_fiscal_name}
                                                            onChange={ (event) => this.onChangeInput('basic_info_fiscal_name', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4>Domicilio</h4>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Dirección *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_address}
                                                            onChange={ (event) => this.onChangeInput('basic_info_address', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>País *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_country}
                                                            onChange={ (event) => this.onChangeInput('basic_info_country', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Provincia *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_province}
                                                            onChange={ (event) => this.onChangeInput('basic_info_province', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Población *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_city}
                                                            onChange={ (event) => this.onChangeInput('basic_info_city', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Código Postal *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_postal_code}
                                                            onChange={ (event) => {
                                                                const postal_code = event.target.value;
                                                                if (isInt(postal_code) || postal_code === '') {
                                                                    this.onChangeInput('basic_info_postal_code', postal_code);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4>Contacto</h4>
                                            <div className="row">
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                        <input
                                                            className="form-control"
                                                            type="email"
                                                            value={basic_info_email}
                                                            onChange={ (event) => this.onChangeInput('basic_info_email', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Teléfono</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_phone}
                                                            onChange={ (event) => this.onChangeInput('basic_info_phone', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Móvil</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_mobile_phone}
                                                            onChange={ (event) => this.onChangeInput('basic_info_mobile_phone', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Fax</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={basic_info_fax}
                                                            onChange={ (event) => this.onChangeInput('basic_info_fax', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4>Persona de Contacto</h4>
                                            <div className="row">
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={contact_person_name}
                                                            onChange={ (event) => this.onChangeInput('contact_person_name', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                        <input
                                                            className="form-control"
                                                            type="email"
                                                            value={contact_person_email}
                                                            onChange={ (event) => this.onChangeInput('contact_person_email', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Teléfono</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={contact_person_phone}
                                                            onChange={ (event) => this.onChangeInput('contact_person_phone', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <h4>Datos bancarios</h4>
                                            <div className="row">
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Forma de pago *</label>
                                                        <Select
                                                            className="virtualized-select"
                                                            options={paymentTypes.toJS()}
                                                            value={payment_type}
                                                            labelKey="type_name"
                                                            valueKey="type_code"
                                                            matchProp="type_name"
                                                            multi={false}
                                                            searchable={true}
                                                            clearable={false}
                                                            onChange={(valueSelected) => {
                                                                if (valueSelected) {
                                                                    this.onChangeInput('payment_type', valueSelected.type_code);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label>Banco *</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={bank_info_name}
                                                            onChange={ (event) => this.onChangeInput('bank_info_name', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>IBAN</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={bank_info_iban}
                                                            onChange={ (event) => this.onChangeInput('bank_info_iban', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-3">
                                                    <div className="form-group">
                                                        <label>Swift</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={bank_info_swift}
                                                            onChange={ (event) => this.onChangeInput('bank_info_swift', event.target.value) }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const seriesReducer = state.series;

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createCustomer: (customer) => dispatch(createCustomer(customer)),
        getSeries: (query) => dispatch(getSeries(query)),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCustomer);



// WEBPACK FOOTER //
// ./src/containers/sales/customers/NewCustomer.js